import paramsFactory from "../../utils/paramsFactory";
import api from "../apiConfig";

// eslint-disable-next-line import/no-anonymous-default-export
export default {
  index(params) {
    const p = paramsFactory(params);
    return api.get(`/api/admin/support-tickets?${p}`);
  },
  show(id) {
    return api.get(`/api/admin/support-tickets/${id}`);
  },
  updateStatus(id, data) {
    return api.put(`/api/admin/support-tickets/${id}/status`, data);
  },
  addComment(id, data) {
    return api.post(`/api/admin/support-tickets/${id}/comments`, data);
  },
};
